// extracted by mini-css-extract-plugin
export default {"container":"WY-z","list":"XY-z"};